module.exports = __webpack_public_path__ + "img/K007.png";